import { transparentize } from "@chakra-ui/theme-tools";
import { colors } from "./colors";

export const shadows = {
  // css `outline` is typically used to add a focus ring around elements.
  // However, Chakra removes this outline ring by setting it to `none` and
  // instead uses a box shadow for the same purpose. You can set this box
  // shadow styling here to override the default blue focus ring on **most**
  // components (others need to be configured through the component theme).
  // https://github.com/chakra-ui/chakra-ui/discussions/1921
  outline: `0 0 0 2px ${transparentize("primary.300", 0.6)({ colors })}`,

  blue: `0 0 0 2px ${transparentize("blue.500", 0.6)({ colors })}`,

  // replace the outline with this invalid when there is an
  // error state on a form input
  invalid: `0 0 0 2px ${transparentize("error.500", 0.6)({ colors })}`,
};
